export default "__VITE_ASSET__DHkNJXyY__"